export default __webpack_public_path__ + "static/media/logo-bumn.768ee43d.png";